import { render, staticRenderFns } from "./awaitAllot.vue?vue&type=template&id=3e1b4c34&scoped=true&"
import script from "./awaitAllot.vue?vue&type=script&lang=js&"
export * from "./awaitAllot.vue?vue&type=script&lang=js&"
import style0 from "./awaitAllot.vue?vue&type=style&index=0&id=3e1b4c34&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e1b4c34",
  null
  
)

export default component.exports